import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";
import shadows, { Shadows } from "@mui/material/styles/shadows";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1a73e8",
    },
    secondary: {
      main: "#f6f8fc",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#f6f8fc",
    },
    text: {
      primary: "#202124",
    },
  },
  shadows: shadows.map(() => "none") as Shadows,
});

export default theme;
